<!-- Default form login -->

<div *ngIf="isLoading">
  <app-loading-spinner></app-loading-spinner>
</div>
<div></div>
<form
  *ngIf="!isLoading"
  (ngSubmit)="onSubmit(RegisterForm)"
  #RegisterForm="ngForm"
  [formGroup]="validatingForm"
  class="text-center border border-light p-5 col-md-6 "
  style="margin: 0 auto;"
>
  <p class="h4 mb-4">Sign in</p>
  <p class="alert alert-primary">
    To log in As Admin : username : Admin@admin.com password : 123456
  </p>
  <p class="alert alert-primary">
    To log in As user : username : test@test.com password : testpwd
  </p>
  <!-- Email -->
  <input
    type="email"
    id="defaultRegisterFormEmail"
    formControlName="email"
    class="form-control mb-4"
    placeholder="E-mail"
  />

  <!-- Password -->
  <input
    [type]="ShowPassword ? 'text' : 'password'"
    id="defaultRegisterFormPassword"
    formControlName="password"
    class="form-control"
    placeholder="Password"
    aria-describedby="defaultRegisterFormPasswordHelpBlock"
  />
  <p (click)="toggleEye()">
    <i [class]="ShowPassword ? 'fa-eye far' : 'fa-eye-slash far'"></i>
  </p>

  <p class="alert alert-danger " *ngIf="message">
    {{ message }}
  </p>
  <!-- Sign in button -->
  <button mdbBtn color="danger" block="true" class="my-4" type="submit">
    Sign in
  </button>

  <!-- Register -->
  <p>
    Not a member?
    <a [routerLink]="['/register']" routerLinkActive="router-link-active"
      >Register</a
    >
  </p>

  <!-- Social login -->
  <p>or sign in with:</p>

  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="facebook"></mdb-icon>
  </a>
  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="twitter"></mdb-icon>
  </a>
  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="linkedin"></mdb-icon>
  </a>
  <a type="button" class="light-blue-text mx-2">
    <mdb-icon fab icon="github"></mdb-icon>
  </a>
</form>
<!-- Default form login -->
